const TIME_FORMAT = 'HH:mm:ss';
const TIME_SHORT_FORMAT = 'HH:mm';
const DATE_SLASH_FORMAT = 'DD/MM/YYYY';
const DATE_TIME_SLASH_FORMAT = `${DATE_SLASH_FORMAT} ${TIME_FORMAT}`;
const DATE_TIME_SLASH_SHORT_FORMAT = `${DATE_SLASH_FORMAT} ${TIME_SHORT_FORMAT}`;

export default {
  TIME_FORMAT,
  TIME_SHORT_FORMAT,
  DATE_TIME_SLASH_FORMAT,
  DATE_TIME_SLASH_SHORT_FORMAT,
};
